import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/pages/supporters-voice.module.scss';
import { Layout } from 'components/organisms/layout';
import { ContentsTitle } from 'components/molecules';
import { SupporterVoice } from 'components/organisms';

import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';

export const SupportersVoice: React.FC = () => {
  return (
    <Layout>
      <div className={styles.supportersVoicePageWrapper}>
        <ContentsTitle
          className={styles.contentsTitle}
          title={
            <>
              SUPPORTER’S <br className={styles.spOnly} />VOICE＆PHOTO
            </>
          }
          subTitle="サポーターの皆さまの声とペットのお写真"
        />
        <a
          href="https://mecgroup.app.box.com/f/c6e816b951d64ea39a306c44733ed4d5"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.photoLink}
        >
          お写真投稿はこちら
          <GreenCircleArrow className={styles.icon} />
        </a>
        <div className={styles.content}>
          <SupporterVoice />
        </div>
        <Link className={styles.topLink} to="/">
          <BlackCircleArrow className={styles.navButton} />トップページへ戻る
        </Link>
      </div>
    </Layout>
  );
};
